module.exports = __webpack_public_path__ + "static/media/birdHouse.6d5cb25c.png";